module.exports = __webpack_public_path__ + "static/img/3_2_1.ec1144ee.jpg";